<mat-expansion-panel class="review-panel">
  <mat-expansion-panel-header>
    <mat-panel-description>
      <mat-icon>article</mat-icon>

      Agent run status
      @if (status$ | async; as status) {
        <mat-chip
          class="warning-chip"
          [class]="{
            'primary-chip': status.status === 'COMPLETED',
            'error-chip': status.status === 'FAILED',
            'in-progress-chip': status.status === 'IN_PROGRESS'
          }">
          <mat-icon matChipAvatar> {{ status.status | statusIcon }}</mat-icon>
          <span> {{ status.status | agentStatus }}</span>
        </mat-chip>
      }
    </mat-panel-description>
  </mat-expansion-panel-header>

  @if (status$ | async; as status) {
    <mat-card-content class="status-actions">
      <button
        *appRequiredRoles="['admin']"
        mat-flat-button
        (click)="triggerAgent()"
        [disabled]="
          triggerLoading || (statusLoading$ | async) || status.status === 'IN_PROGRESS' || isDisabledEdit
        ">
        @if (!triggerLoading) {
          <mat-icon>
            {{ status.status === 'IN_PROGRESS' ? 'skip_next' : 'play_arrow' }}
          </mat-icon>
        }

        <span>
          {{ triggerLoading ? 'Processing...' : status.status === 'IN_PROGRESS' ? 'Rerun Agent' : 'Trigger Agent' }}
        </span>
      </button>

      <button
        mat-icon-button
        (click)="refetch()"
        [disabled]="(statusLoading$ | async) || isDisabledEdit"
        matTooltip="Manual Refresh">
        <mat-icon>refresh</mat-icon>
      </button>
      @if (lastUpdated) {
        <p class="caption footer-info">Last update: {{ lastUpdated | date: 'shortTime' }}</p>
      }
    </mat-card-content>
  } @else {
    <mat-card-content class="loading-state-content">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Fetching workflow status...</p>
    </mat-card-content>
  }
  @if ((statusLoading$ | async) && !triggerLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</mat-expansion-panel>
